import { useDocumentTitle } from "usehooks-ts";
import { FeatureList } from "./FeatureList";
import { MainCoursesList } from "./MainCoursesList";
import { Hero } from "./Hero";
import { Testimonials } from "./Testimonials";
import { PricingContainer } from "./PricingContainer";
import { Faq } from "./Faq";
import { FooterCta } from "./FooterCta";
import { Footer } from "./Footer";
import { SignupModal } from "./Signup/SignupModal";
import { HomepageSignupContextProvider } from "./HomepageSignupContext";
import { useEffect, useRef } from "react";
import { Stat } from "./Stat";
import { EmptyLearnerPage } from "../Layouts/EmptyLearnerPage";
import BackToDeltamathBanner from "./BackToDeltamathBanner";
import { DeltieGenerator } from "./DeltieGenerator/DeltieGenerator";
// import { PrepCoursesList } from "./PrepCoursesList";
import { OfferExpiredBanner } from "./OfferExpiredBanner";
import { VoucherLandingContent } from "./types";
import { useLocation } from "react-router-dom";

export const HomePage: React.FC<{
  showPromoPrice?: boolean;
  allowPromoCode?: boolean;
  voucherLandingContent?: VoucherLandingContent;
}> = ({
  showPromoPrice = false,
  allowPromoCode = false,
  voucherLandingContent,
}) => {
  useDocumentTitle("DeltaMath for Home");

  const plansRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();

  // Scroll to top when linking from one version of the homepage to another
  // (e.g. landing on /home but then clicking to pay with a voucher)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <EmptyLearnerPage title={undefined} dontTrackTime>
      <div className="h-full w-full">
        {!voucherLandingContent && (
          <>
            <BackToDeltamathBanner />
            <OfferExpiredBanner />
          </>
        )}
        <HomepageSignupContextProvider
          plansRef={plansRef}
          showPromoPrice={showPromoPrice}
          voucherLandingContent={voucherLandingContent}
        >
          <main className="bg-dm-background-blue flex min-h-dvh w-full flex-col items-center gap-20 bg-dm-background-blue-100 md:gap-32 xl:gap-44">
            <Hero />
            <PricingContainer ref={plansRef} />
            {/* This is more of a summer thing. Leaving the component in case we resurrect it next year */}
            {/* <PrepCoursesList /> */}
            <MainCoursesList />
            <FeatureList />
            <Stat />
            <Testimonials />
            <Faq />
            <DeltieGenerator />
            <FooterCta />
            <Footer />

            <SignupModal allowPromoCode={allowPromoCode} />
          </main>
        </HomepageSignupContextProvider>
      </div>
    </EmptyLearnerPage>
  );
};
